import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { EnumGroupStatisticSourceOrders } from "../../../../../../server/routes/statistic/getSourceOrders/types";
import { Field } from "../../../../components/ContainerFields";
import SelectField from "../../../../components/SelectField";
import { actionGroupChange } from "../../../../store/statisticSourceOrders/actions";
import { useStatusGroup } from "../../StatusGroupProvider";
import { FieldGroupingFC } from "./types";

const variants = [
  { value: EnumGroupStatisticSourceOrders.MONTH, label: "Месяцам" },
  { value: EnumGroupStatisticSourceOrders.WEEK, label: "Неделям" },
];

const FieldGrouping: FieldGroupingFC = ({ loading }) => {
  const dispatch = useDispatch();
  const { statusGroup } = useStatusGroup();
  const handlerChange = async (
    value: EnumGroupStatisticSourceOrders | string
  ) => {
    if (
      value == EnumGroupStatisticSourceOrders.WEEK ||
      value == EnumGroupStatisticSourceOrders.MONTH
    ) {
      dispatch(actionGroupChange(statusGroup, value));
      loading({ group: value });
    }
  };
  const { value } = useSelector(
    ({
      statisticSourceOrders: {
        [statusGroup]: { group },
      },
    }) => ({
      value: group,
    })
  );
  return (
    <Field GridProps={{ xs: 12, sm: 4 }}>
      <SelectField
        onChange={handlerChange}
        size={"small"}
        items={variants}
        value={value}
        label={"Групировка по"}
        hideClearButton
      />
    </Field>
  );
};

export default FieldGrouping;
